/**
 * Clone a value into JSON-only data so Tauri IPC / Sentry breadcrumbs can
 * serialize it. Cycles become the string `[Cycle]`; unserializable input
 * becomes `undefined`.
 */
export const jsonSafeClone = <T>(value: T): T | undefined => {
  if (value === undefined) return undefined;
  const seen = new WeakSet<object>();
  try {
    return JSON.parse(
      JSON.stringify(value, (_key, current: unknown) => {
        if (typeof current === 'bigint') return String(current);
        if (typeof current === 'object' && current !== null) {
          if (seen.has(current)) return '[Cycle]';
          seen.add(current);
        }
        return current;
      })
    ) as T;
  } catch {
    return undefined;
  }
};
